import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface ColorPickerFieldProps {
  value: string;
  onChange: (color: string) => void;
  colorOptions: { name: string; value: string }[];
}

const ColorPickerField: React.FC<ColorPickerFieldProps> = ({ value, onChange, colorOptions }) => {
  return (
    <div style={{ marginBottom: '16px' }}>
      <label style={{
        display: 'block',
        marginBottom: '8px',
        fontSize: '13px',
        fontWeight: '500',
        color: '#374151'
      }}>
        Color
      </label>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(32px, 1fr))',
        gap: '6px',
        maxWidth: '480px',
        maxHeight: '200px',
        overflowY: 'auto'
      }}>
        {colorOptions.map((option, index) => (
          <button
            key={`${option.value}-${index}`}
            type="button"
            onClick={() => onChange(option.value)}
            style={{
              width: '32px',
              height: '32px',
              backgroundColor: option.value,
              border: value === option.value ? '2px solid #374151' : '1px solid #e5e7eb',
              borderRadius: '4px',
              cursor: 'pointer',
              position: 'relative'
            }}
            title={option.name}
          >
            {value === option.value && (
              <CheckCircle2
                size={14}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: '#ffffff',
                  filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))'
                }}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ColorPickerField;
